var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.402 6.496C15.551 2.596 12.752.633 9 .633 5.246.633 2.45 2.596.598 6.498a1.178 1.178 0 000 1.006c1.851 3.9 4.65 5.863 8.402 5.863 3.754 0 6.55-1.963 8.402-5.865.15-.316.15-.684 0-1.006zM9 11.961c-3.15 0-5.457-1.598-7.084-4.961C3.543 3.637 5.85 2.04 9 2.04c3.15 0 5.457 1.597 7.084 4.96-1.625 3.363-3.932 4.96-7.084 4.96zm-.078-8.399a3.438 3.438 0 100 6.876 3.438 3.438 0 000-6.876zm0 5.626A2.186 2.186 0 016.734 7c0-1.209.979-2.188 2.188-2.188a2.186 2.186 0 110 4.375z",
    fill: "#FF7A45"
  })));
}

export default __webpack_public_path__ + "./fonts/eye.dfc61ed125e0ca48cdaa4b8e1d84ecbe.svg";
export { SvgEye as ReactComponent };